export default __webpack_public_path__ + "static/step3-086bd7e3b19ba14f03ef35e3bfc83f3f.svg";